"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_1 = require("react");
const currency_symbol_map_1 = __importDefault(require("currency-symbol-map"));
const AppBar_1 = __importDefault(require("@mui/material/AppBar"));
const Toolbar_1 = __importDefault(require("@mui/material/Toolbar"));
const Select_1 = __importDefault(require("@mui/material/Select"));
const MenuItem_1 = __importDefault(require("@mui/material/MenuItem"));
const Box_1 = __importDefault(require("@mui/material/Box"));
const FormControl_1 = __importDefault(require("@mui/material/FormControl"));
const EditRounded_1 = __importDefault(require("@mui/icons-material/EditRounded"));
const DeleteRounded_1 = __importDefault(require("@mui/icons-material/DeleteRounded"));
const luxon_1 = require("luxon");
const mui_1 = require("tss-react/mui");
const core_1 = require("companion-app-components/utils/core");
const QMonthNavigator_1 = __importDefault(require("components/QMonthNavigator"));
const QButton_1 = __importDefault(require("components/QButton"));
const constants_1 = require("containers/BudgetsV2/constants");
const utils_1 = require("../../utils");
const hooks_1 = require("../../hooks");
const NestedDropDown_1 = __importDefault(require("../NestedDropDown"));
const styles_1 = __importDefault(require("./styles"));
const budgetMonthEditable = true;
const useStyles = (0, mui_1.makeStyles)()(styles_1.default);
const BudgetHeader = ({ isLoading, budget, budgets, budgetsCreation, goNextMonth, goPrevMonth, goThisMonth, handleBudgetChange, startDate, onDelete, onEdit, handleViewChange, handleAnnualSubViewChange, dashboardRef, }) => {
    const { classes, theme } = useStyles();
    const { id, name } = budget;
    const { isToDateColumnEnabled, budgetView, annualSubView, setDatasetPreference, showFutureMonthDetails, } = (0, hooks_1.useBudgetOptions)(id, dashboardRef);
    const handleShowToDateSetting = () => {
        setDatasetPreference({ budgetOptions: { showToDateColumn: !isToDateColumnEnabled } });
        core_1.tracker.track(core_1.tracker.events.viewBudgetOptions, { showToDateColumn: isToDateColumnEnabled ? 'Unchecked' : 'Checked' });
    };
    (0, react_1.useEffect)(() => {
        let budgetsBarObserver = null;
        const budgetsBarSentinel = document.querySelector('#budgetsBarSentinel');
        if (budgetsBarSentinel && typeof IntersectionObserver !== 'undefined') {
            budgetsBarObserver = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        // setBudgetMonthEditable(false);
                    }
                    else {
                        // setBudgetMonthEditable(true);
                    }
                });
            }, {
                root: null,
                rootMargin: `-${theme.defaults.headers.headerHeight}px 0px 0px 0px`,
                threshold: 0,
            });
            budgetsBarObserver.observe(budgetsBarSentinel);
        }
        // PUT the monthly view in datasetPrereference, ONLY when user redirects from dashboard card
        // So, it doesn't jump to annual view when user clicks on breadcrumb or any budgetItem in monthly view.
        if (dashboardRef === 'dashboard' && budgetView === constants_1.BUDGET_VIEWS.monthly.key) {
            setTimeout(() => {
                setDatasetPreference((0, utils_1.getBudgetViewStateObject)(id, name, budgetView, annualSubView, showFutureMonthDetails));
            }, 1000);
        }
        return () => {
            budgetsBarObserver === null || budgetsBarObserver === void 0 ? void 0 : budgetsBarObserver.disconnect();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const selectOutlineSx = (muiTheme) => ({
        '& .MuiOutlinedInput-notchedOutline': { borderColor: muiTheme.palette.border.default },
        '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: muiTheme.palette.border.default },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: muiTheme.palette.border.default, borderWidth: '1px' },
    });
    if (isLoading)
        return null;
    return (<AppBar_1.default position="sticky" elevation={0} className={classes.header}>
      <Toolbar_1.default className={classes.headerContent}>
        <Box_1.default sx={{ flexGrow: 1 }}>
          {budgets && (budgets === null || budgets === void 0 ? void 0 : budgets.size) > 1 &&
            <FormControl_1.default id="budgets-page-dropdown">
              <Select_1.default id="budgets-page-select" value={budget ? `${id}` : ''} onChange={(evt) => handleBudgetChange(evt)} variant="outlined" size="small" sx={selectOutlineSx}>
                {budgets && budgets.valueSeq().map((theBudget, index) => (<MenuItem_1.default id={`budgets-select-${index}`} value={theBudget.id} key={theBudget.id}>
                    {theBudget.name}
                    {budgets
                        && theBudget.currency
                        && budgets.reduce((set, aBudget) => { set.add(aBudget.currency); return set; }, new Set()).size > 1
                        && ` (${(0, currency_symbol_map_1.default)(theBudget.currency)})`}
                  </MenuItem_1.default>))}
              </Select_1.default>
            </FormControl_1.default>}
          <FormControl_1.default id="budgets-view-dropdown" sx={{ ml: 2 }}>
            <Select_1.default id="budgets-view-select" value={budgetView} variant="outlined" size="small" onChange={(evt) => handleViewChange(budget, annualSubView, evt)} sx={(muiTheme) => ({
            '& .MuiOutlinedInput-notchedOutline': { borderColor: muiTheme.palette.border.default },
            '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: muiTheme.palette.border.default },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: muiTheme.palette.border.default, borderWidth: '1px' },
        })}>
              {Object.values(constants_1.BUDGET_VIEWS).map(({ key, label }) => <MenuItem_1.default value={key} key={key}>{label}</MenuItem_1.default>)}
            </Select_1.default>
          </FormControl_1.default>
          {budgetView === constants_1.BUDGET_VIEWS.annual.key && (<FormControl_1.default id="budgets-annual-subview-dropdown" sx={{ ml: 2 }}>
              <Select_1.default id="budgets-annual-subview-select" value={annualSubView} variant="outlined" size="small" onChange={(evt) => handleAnnualSubViewChange(budget, budgetView, evt)} sx={selectOutlineSx}>
                {Object.values(constants_1.BUDGET_ANNUAL_SUBVIEWS).map(({ key, label }) => <MenuItem_1.default value={key} key={key}>{label}</MenuItem_1.default>)}
              </Select_1.default>
            </FormControl_1.default>)}
          {budgetView === constants_1.BUDGET_VIEWS.monthly.key && (<FormControl_1.default id="budgets-date-navigator" sx={{ ml: 2 }}>
              <QMonthNavigator_1.default date={luxon_1.DateTime.fromJSDate(startDate)} onPreviousClick={goPrevMonth} onCurrentClick={goThisMonth} onNextClick={goNextMonth}/>
            </FormControl_1.default>)}
        </Box_1.default>

        {budgetsCreation && budgetView !== constants_1.BUDGET_VIEWS.annual.key &&
            <>
            <QButton_1.default onClick={onDelete}>
              <DeleteRounded_1.default style={{ marginRight: 7 }}/>
              {`Delete ${name}`}
            </QButton_1.default>

            {budgetMonthEditable &&
                    <QButton_1.default onClick={onEdit} color="secondary">
                <EditRounded_1.default style={{ marginRight: 7 }}/>
                {`Edit ${name} `}
              </QButton_1.default>}
          </>}
        {budgetView === constants_1.BUDGET_VIEWS.annual.key && (<NestedDropDown_1.default menuItemsData={(0, utils_1.budgetOptions)({
                isToDateColumnEnabled,
                handleShowToDateSetting,
            })} 
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        MenuProps={{ elevation: 3 }} ButtonProps={{ variant: 'outlined' }}/>)}
      </Toolbar_1.default>
    </AppBar_1.default>);
};
exports.default = React.memo(BudgetHeader);
